import type { SupportedLanguage } from '@/utils/globalTypes';

type TranslationResource = Record<string, unknown>;
type TranslationModule = TranslationResource | { default: TranslationResource };
type TranslationContext = {
  keys: () => string[];
  <T = TranslationModule>(id: string): T;
};

declare const require: {
  context: (directory: string, useSubdirectories?: boolean, regExp?: RegExp) => TranslationContext;
};

const translationContext = require.context('../../translations', true, /\.json$/);
const translationKeys = new Set(translationContext.keys());

export function getClientNamespaceResources(lang: SupportedLanguage, namespace: string): TranslationResource {
  const key = `./${lang}/${namespace}.json`;

  if (!translationKeys.has(key)) {
    throw new Error(`Missing client translation bundle for ${lang}/${namespace}`);
  }

  const mod = translationContext<TranslationModule>(key);
  return (mod && 'default' in mod ? mod.default : mod) as TranslationResource;
}
